import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import React from 'react';
import { ContratoAction, useContrato } from '../store';

const ContratoFab = () => {
  const [state, dispatch] = useContrato();

  const { selecionados, tipoSelecao, requestParams, filtroAvancado } = state;

  // RNE-495
  const possuiRegistroAtivo = selecionados?.some((contrato) => contrato.situacao === 'ATIVO');

  const excluir = () => {
    // RNE-495
    const idsSelecionados = selecionados
      ?.filter((contrato) => contrato.situacao === 'ATIVO')
      ?.map((contrato) => contrato.id);

    ContratoAction.requestExcluir(dispatch, idsSelecionados, requestParams, tipoSelecao, filtroAvancado);
  };

  const cadastrar = () => {
    dispatch(ContratoAction.cadastrar());
  };

  const actions = [];

  if (permissaoUtils.contrato().cadastrar) {
    /* actions.push({
       icon: <FaCloudUploadAlt />,
       name: 'import',
       tooltip: 'Importar planilha',
       onClick: () => {},
    }); */
  }

  // RNE-506
  if (
    permissaoUtils.contrato().excluir &&
    (tipoSelecao === 'TODOS_FILTRO' || (selecionados?.length > 0 && possuiRegistroAtivo))
  ) {
    actions.push({
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.contrato().excluir,
      onClick: excluir,
    });
  }

  if (permissaoUtils.contrato().cadastrar) {
    actions.push({
      icon: <AddIcon />,
      name: 'cadastrar',
      tooltip: 'Cadastrar',
      show: permissaoUtils.contrato().cadastrar,
      onClick: cadastrar,
    });
  }

  return <TableActions className={'stepPlusButton'} actions={actions} />;
};

export default ContratoFab;
